module.exports = __webpack_public_path__ + "img/c08_unitmerchanttransport_Normal_ua.114e7984.webp";